import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { Machine } from '../machine';

export class MachineBuilder {
  static fromJson(json) {
    return (json)
      ? new Machine(
        json.hash,
        json.name,
        json.code,
        json.active,
        json.fileType,
        json.path,
        json.inputPath,
        json.outputPath,
        json.successPath,
        json.failedPath,
        json.isZoller,
        json.isHaimer
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByString('name', mapCollection(MachineBuilder.fromJson, list)) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/machine.builder.ts